import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import PropTypes from 'prop-types'
import React, { Fragment, useState } from 'react'
import Button from '../../../../../components/Button/Button'
import RadioButton from '../../../../../components/RadioButton/RadioButton'

const AfterHoursModal = ({ isOpen, setIsOpen, onSubmit }) => {
    const [afterHoursApproval, setAfterHoursApproval] = useState(false)

    const closeModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-3xl bg-white md:p-12 p-4 text-center transition-all relative flex flex-col items-center justify-start gap-y-6">
                                    <XIcon
                                        className="w-6 h-6 stroke-current absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg text-black90 font-semibold"
                                    >
                                        After Hours
                                    </Dialog.Title>
                                    <p className="mt-1 text-textDarkGray text-sm font-normal text-left">
                                        We’re currently past the service cutoff
                                        time for the day. Are you willing to pay
                                        the after-hours rates* for same-day
                                        service?
                                    </p>

                                    <div className="w-full h-auto flex flex-col items-start justify-start gap-y-6">
                                        <RadioButton
                                            label="Pay after-hours rate"
                                            checked={true}
                                            value={afterHoursApproval === true}
                                            onChange={() =>
                                                setAfterHoursApproval(true)
                                            }
                                            isTextBlack
                                        />
                                        <RadioButton
                                            label="Service during the next business day"
                                            checked={true}
                                            value={afterHoursApproval === false}
                                            onChange={() =>
                                                setAfterHoursApproval(false)
                                            }
                                            isTextBlack
                                        />
                                    </div>

                                    <Button
                                        text="Submit"
                                        variant="primary"
                                        onClick={() => {
                                            onSubmit(afterHoursApproval)
                                        }}
                                        className="w-full"
                                        type="button"
                                    />
                                    <p className="font-medium text-sm text-textDarkGray">
                                        *Rate depends on your contract
                                    </p>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

AfterHoursModal.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    onSubmit: PropTypes.func,
}

export default AfterHoursModal
